import ExternalConfirmation from "./ExternalConfirmation";

export default ExternalConfirmation;